<p-panel>
    <p-header>
       <label i18n="@@labelHeaderText1">Perfil</label>
    </p-header>
  <hr />
  <h3 i18n="@@labelH3Text1" class="header-cliente">Dados Cadastrais</h3>
  <hr />
  <div class="ui-g">
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-cliente">
      <label i18n="@@labelText1">Código</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 ui-fluid">{{ ordemServico.cliente.codigo }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-cliente">
      <label i18n="@@labelText2">Nome / Razão</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 ui-fluid">{{ ordemServico.cliente.nomeTitular }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-cliente">
      <label i18n="@@labelText3">RG</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6">{{ ordemServico.cliente.rg }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-cliente">
      <label i18n="@@labelText4">CPF / CNPJ</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 ui-fluid">
        <output [mask]="mask"  type="text" name="documento" [(ngModel)]="documento"></output>
    </div>
  </div>
  <hr />
  <h3 i18n="@@labelH3Text2" class="header-cliente">Contatos</h3>
  <hr />
  <div class="ui-g">
    <div class="ui-md-3 ui-sm-4 ui-g-4 label-cliente">
     <label i18n="@@labelText5">Email</label>
    </div>
    <div class="ui-md-3 ui-sm-4 ui-g-4 ui-fluid">{{ ordemServico.cliente.email }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-cliente">
     <label i18n="@@labelText6">Telefone</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 ui-fluid">{{ ordemServico.cliente.foneResidencia }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-cliente">
     <label i18n="@@labelText7">Celular</label> 
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 ui-fluid">{{ ordemServico.cliente.celular }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-cliente">
     <label i18n="@@labelText8">Outros Contatos</label> 
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 ui-fluid"></div>
  </div>
</p-panel>

